import { createContext } from "react";

const GlobalEditorIsEditable = createContext<boolean>(null);

export default GlobalEditorIsEditable;
